module.exports = __webpack_public_path__ + "ke.732c2b39.svg";